import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, BASE } from "@/lib/api";

export const abs = (u) => (!u ? null : /^https?:\/\//i.test(u) ? u : `${BASE}${u.startsWith("/") ? "" : "/"}${u}`);
export const SOCIALS = [["linkedin", "LinkedIn"], ["instagram", "Instagram"], ["facebook", "Facebook"], ["youtube", "YouTube"], ["x", "X (Twitter)"]];
export const FIELDS = [["fullName", "Full Name *"], ["designation", "Designation"], ["company", "Company"], ["phone", "Phone"], ["whatsapp", "WhatsApp"], ["email", "Email"], ["website", "Website"], ["address", "Address"]];
const EDITABLE = ["enabled", "fullName", "designation", "company", "phone", "whatsapp", "email", "address", "website", "about", "socials"];

export const cardBody = (c) => Object.fromEntries(EDITABLE.map((k) => [k, c?.[k] ?? (k === "socials" ? {} : k === "enabled" ? true : "")]));
const withLiveLinks = (d) => {
  if (!d?.card?.slug) return d;
  const base = `${window.location.origin}/api/card/${d.card.slug}`;
  return { ...d, card: { ...d.card, publicUrl: base, qrUrl: `${base}/qr.png`, vcardUrl: `${base}/vcard` } };
};
export const useDbc = () => useQuery({ queryKey: ["dbc"], queryFn: () => api.get("/dbc/me"), retry: false, select: withLiveLinks });
export const useSaveDbc = () => {
  const qc = useQueryClient();
  return async (body) => {
    const card = await api.put("/dbc/me", body);
    qc.invalidateQueries({ queryKey: ["dbc"] });
    return card;
  };
};

export const THEMES = [["#0000EC", "TOTO Blue"], ["#047857", "Emerald"], ["#EA580C", "Sunset"], ["#1F2937", "Charcoal"], ["#6D28D9", "Royal Purple"], ["#E11D48", "Rose"]];
export const DEFAULT_THEME = THEMES[0][0];
export const useDbcExtra = (enabled = true) => useQuery({ queryKey: ["dbc-extra"], queryFn: () => api.get("/dbc-extra/me", { local: true }), retry: false, enabled });

export const saveTheme = (color, pattern) => api.put("/dbc-extra/theme", { color, pattern }, { local: true });
const W = "rgba(255,255,255,.24)";
const WAVE = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='20'%3E%3Cpath d='M0 10 Q20 0 40 10 T80 10' fill='none' stroke='rgba(255,255,255,.3)' stroke-width='2'/%3E%3C/svg%3E\")";
export const PATTERNS = [
  ["plain", "Plain", null],
  ["dots", "Dots", [`radial-gradient(${W} 1.5px, transparent 1.6px)`, "18px 18px"]],
  ["waves", "Waves", [WAVE, "80px 20px"]],
  ["lines", "Diagonal Lines", ["repeating-linear-gradient(45deg, rgba(255,255,255,.16) 0 2px, transparent 2px 12px)", "auto"]],
  ["grid", "Grid", ["linear-gradient(rgba(255,255,255,.16) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.16) 1px, transparent 1px)", "20px 20px, 20px 20px"]],
];
export const bannerStyle = (color, pattern = "plain") => {
  const p = PATTERNS.find(([k]) => k === pattern)?.[2];
  return p ? { backgroundColor: color, backgroundImage: p[0], backgroundSize: p[1] } : { backgroundColor: color };
};

export async function copyText(t) {
  try { await navigator.clipboard.writeText(t); return true; } catch { return false; }
}
